import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, CreditCard, ShieldCheck, Download } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 md:px-6 lg:px-8 w-full overflow-hidden" data-id="element-113">
      
      {/* Glows ajustados para abarcar toda la pantalla sin cortes duros */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-10" data-id="element-114">
        <div className="absolute top-[-20%] left-[-10%] w-[60vw] h-[60vw] bg-cyan-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-115" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] bg-green-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-116" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-117">
        {/* LADO IZQUIERDO: Copywriting con contexto Venezolano */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-start w-full" data-id="element-118">
          <motion.div animate={{
          opacity: [0.8, 1, 0.8]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-flex items-center justify-center text-center px-4 py-2.5 rounded-2xl sm:rounded-full bg-cyan-400/10 border border-cyan-400/20 text-cyan-400 text-xs sm:text-sm font-bold mb-6 tracking-wide w-full sm:w-auto" data-id="element-119">
            🇻🇪 A prueba de apagones: Resuelve todo desde tu celular
          </motion.div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] mb-6 tracking-tight w-full" data-id="element-120">
            ¿Tus clientes te preguntan "Precio" y luego te dejan{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400 drop-shadow-[0_0_15px_rgba(34,211,238,0.3)]" data-id="element-121">
              EN VISTO?
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-xl leading-relaxed font-light" data-id="element-122">
            Sobrevivir con un negocio en Venezuela no es fácil. Descubre el Toolkit Pro con <strong className="text-white font-semibold" data-id="element-123">100 plantillas de Canva</strong> y <strong className="text-white font-semibold" data-id="element-124">guiones de WhatsApp</strong> que cierran ventas. Vende, calcula tu tasa BCV rápido y cobra sin rogar.
          </p>

          <div className="flex flex-col w-full sm:w-auto gap-5" data-id="element-125">
            
            {/* 👉 CORRECCIÓN: Ahora envía a la sección de personalizar (#comprar) */}
            <motion.a href="#comprar" whileHover={{
            scale: 1.03,
            y: -2
          }} whileTap={{
            scale: 0.97
          }} className="relative flex flex-col items-center justify-center w-full px-8 py-5 bg-gradient-to-r from-green-500 to-cyan-500 rounded-2xl shadow-[0_0_40px_-10px_rgba(34,197,94,0.6)] hover:shadow-[0_0_60px_-15px_rgba(34,197,94,0.8)] transition-all duration-300 border border-white/20 overflow-hidden group cursor-pointer text-decoration-none" data-id="element-126">
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-127" />
              
              <span className="relative z-10 flex items-center justify-center gap-3 text-2xl md:text-3xl font-black text-white tracking-tight drop-shadow-md w-full text-center" data-id="element-128">
                <Download className="w-7 h-7 animate-bounce hidden md:block" data-id="element-129" />
                VER OPCIONES Y DESCARGAR
              </span>
              
              <span className="relative z-10 mt-2 text-sm md:text-base font-bold text-green-50 bg-black/30 px-5 py-1.5 rounded-full backdrop-blur-md border border-white/10 shadow-inner" data-id="element-130">
                Desde $17 (Pago Único)
              </span>
            </motion.a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-1 text-sm text-gray-400" data-id="element-131">
              <div className="flex items-center justify-center w-full sm:w-auto gap-3 bg-white/5 px-4 py-2 rounded-xl border border-white/5 inline-flex" data-id="element-132">
                <span className="flex items-center gap-1.5" data-id="element-133"><Smartphone className="w-4 h-4 text-green-400" data-id="element-134" /> Pago Móvil</span>
                <span className="text-white/20" data-id="element-135">•</span>
                <span className="flex items-center gap-1.5" data-id="element-136">
                  <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 24 24" fill="currentColor" data-id="element-137"><path d="M11.999 0L17.58 5.582l-2.028 2.028-3.553-3.553-3.553 3.553-2.028-2.028L11.999 0zm0 16.516l-4.516-4.516-2.028 2.028 6.544 6.544 6.544-6.544-2.028-2.028-4.516 4.516zm9.58-10.934l2.028 2.028-6.544 6.544-2.028-2.028 6.544-6.544zm-19.16 0l2.028-2.028 6.544 6.544-2.028 2.028-6.544-6.544z" data-id="element-138" /></svg> 
                  Binance
                </span>
                <span className="text-white/20" data-id="element-139">•</span>
                <span className="flex items-center gap-1.5" data-id="element-140"><CreditCard className="w-4 h-4 text-cyan-400" data-id="element-141" /> Tarjetas</span>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 mt-1 text-xs text-gray-500" data-id="element-142">
              <ShieldCheck className="w-4 h-4 text-green-500/70" data-id="element-143" />
              <span data-id="element-144">Garantía de Satisfacción de 7 Días</span>
            </div>
          </div>
        </motion.div>

        {/* LADO DERECHO: Imagen */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end group lg:ml-10 mt-10 lg:mt-0" data-id="element-145">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/20 to-green-500/20 rounded-3xl blur-[40px] group-hover:blur-[60px] transition-all duration-500" data-id="element-146" />
          
          <div className="relative w-full max-w-sm md:max-w-xl rounded-3xl overflow-hidden border border-white/10 shadow-[0_0_60px_rgba(34,211,238,0.2)] transform group-hover:-translate-y-2 transition-transform duration-500 bg-[#050505]" data-id="element-147">
            <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/hero-impact.jpg?v=1773383734" alt="Toolkit del Negocio Digital Pro Layered Showcase" className="w-full h-auto object-contain" data-id="element-148" />
          </div>
        </motion.div>
      </div>
    </section>;
}